import FormProperties from './FormProperties'
import Grid from '@material-ui/core/Grid'
import React, { useEffect, useState } from 'react'
import { components } from 'cng-web-lib'
import { useParams } from 'react-router-dom'
import ConveyanceMasterApiUrls from 'src/apiUrls/ConveyanceMasterApiUrls'
import pathMap from '../../paths/pathMap'
import AlertDialog from '../../components/aciacehighway/AlertDialog'
import { useFormContext } from 'react-hook-form'
import withFormState from '../../components/aciacehighway/hocs/withFormState'
import NaCommonTranslationText from 'src/common/NaCommonTranslationText'

const {
  button: { CngButton },
  form: { CngEditForm }
} = components

function ConveyanceEditPage({ history, loading, onSetLoading, showNotification }) {
  const { id } = useParams()

  return (
    <CngEditForm
      fieldLevel="toBeChangedByDeveloperIfWantFieldLevelRestriction"
      showNotification={showNotification}
      renderBodySection={(labelMap, shouldHideMap) => (
        <FormProperties.Fields
          showNotification={showNotification}
          shouldHideMap={shouldHideMap}
        />
      )}
      formikProps={FormProperties.formikProps}
      toClientDataFormat={FormProperties.toClientDataFormat}
      toServerDataFormat={FormProperties.toServerDataFormat}
      fetch={{ url: ConveyanceMasterApiUrls.GET }}
      update={{ url: ConveyanceMasterApiUrls.PUT }}
      id={id}
      renderButtonSection={(_, loading) => (
        <CustomButtonSection
          history={history}
          loading={loading}
          onSetLoading={onSetLoading}
        />
      )}
    />
  )
}

function CustomButtonSection(props) {
  const { history, loading, onSetLoading } = props
  const [alertDialog, setAlertDialog] = useState(false)
  const naCommonTranslationText = NaCommonTranslationText()

  const {
    formState: { isSubmitting }
  } = useFormContext()

  useEffect(() => {
    onSetLoading(loading)
  }, [loading])

  return (
    <>
      <Grid container justify='space-between' spacing={3}>
        <Grid item xs='auto'>
          <CngButton
            color='secondary'
            disabled={isSubmitting}
            onClick={() => setAlertDialog(true)}
            size='medium'
          >
            {naCommonTranslationText.discard}
          </CngButton>
        </Grid>
        <Grid item xs='auto'>
          <CngButton
            color='primary'
            disabled={isSubmitting}
            type='submit'
            size='medium'
          >
            {naCommonTranslationText.update}
          </CngButton>
        </Grid>
      </Grid>
      <AlertDialog
        cancelLabel={naCommonTranslationText.continueEdit}
        confirmLabel={naCommonTranslationText.confirmDiscard}
        open={alertDialog}
        onClose={() => setAlertDialog(false)}
        onCancel={() => setAlertDialog(false)}
        onConfirm={() => history.push(pathMap.CONV_MAST_LIST_VIEW)}
        title={naCommonTranslationText.discard}
      >
        {naCommonTranslationText.confirmationMessage}
      </AlertDialog>
    </>
  )
}

export default withFormState(ConveyanceEditPage)
